import axios from 'axios';

export const aclInstance = axios.create({
	baseURL: process.env.ACL_URL,
});

export const praktikoInstance = axios.create({
	baseURL: process.env.PRAKTIKO_URL,
});

export const pollInstance = axios.create({
	baseURL: process.env.POLL_ENGINE,
});

export const jobEvaluationInstance = axios.create({
	baseURL: process.env.POLL_ENGINE,
});

export const uploadInstance = axios.create({
	baseURL: process.env.UPLOAD_URL,
});
export const scrapingInstances = axios.create({
	baseURL: process.env.CREDENTIAL_SCRAPER,
});

export default function (Vue) {
	/* eslint-disable no-param-reassign */
	Vue.prototype.$http = pollInstance;
	Vue.prototype.$httpAcl = aclInstance;
	Vue.prototype.$httpPraktiko = praktikoInstance;
	Vue.prototype.$httpUpLoad = uploadInstance;
	Vue.prototype.$httpJobEvaluation = jobEvaluationInstance;
	Vue.prototype.$httpScraper = scrapingInstances;
}



// WEBPACK FOOTER //
// ./src/axios.js